// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{box-sizing:border-box}body{margin:0}.GNG25EOEPnApKD7KHLXi{margin:25px auto;width:50%;min-width:480px}`, "",{"version":3,"sources":["webpack://./src/export/styles.scss"],"names":[],"mappings":"AAAA,EACE,qBAAA,CAGF,KACE,QAAA,CAGF,sBACE,gBAAA,CACA,SAAA,CACA,eAAA","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n}\n\n.parent {\n  margin: 25px auto;\n  width: 50%;\n  min-width: 480px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"parent": `GNG25EOEPnApKD7KHLXi`
};
export default ___CSS_LOADER_EXPORT___;
